import { eSetTieuChuanSanPhamActionTypeDefine } from "../../action-types/set-tieu-chuan/ISetTieuChuanSanPhamActions";
import { generateActions } from "../generateActions";

export const setTieuChuanSanPhamActions = {
    ...generateActions(eSetTieuChuanSanPhamActionTypeDefine, "SET_TIEU_CHUAN_SAN_PHAM"),
}